import React from "react";

export default function Find(){
    return (
        <div>
        <a href="https://www.forjmblog.com/how-to-bring-in-customers-to-your-ecommerce-store/">https://www.forjmblog.com/how-to-bring-in-customers-to-your-ecommerce-store/</a>
        </div>
    )
}